import { createContext, useContext } from 'react'

/**
 * Provide a reference to a row data updater function that will trigger the callback prop
 * as passed to the provider.
 */
export const RowDataContext = createContext<{
  updateRowData: (updates: { id: string; [key: string]: any }[]) => void
} | null>(null)

export const useRowDataContext = () => {
  const context = useContext(RowDataContext)

  if (!context) {
    throw new Error('useRowDataContext must be used within a RowDataContext.Provider')
  }

  return context
}
